export default {
      id: "relatives-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "sprite.svg#relatives-usage",
      toString: function () {
        return this.url;
      }
    }